var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16599 20.5348L5.07636 20.9486C5.22095 20.6305 5.18902 20.26 4.99213 19.9713L4.16599 20.5348ZM1 27.5L0.0896335 27.0862C-0.082858 27.4657 -0.00186039 27.9124 0.292893 28.2071C0.587647 28.5019 1.03432 28.5829 1.4138 28.4104L1 27.5ZM8.1316 24.2584L8.64181 23.3983C8.36056 23.2315 8.0155 23.2127 7.7178 23.348L8.1316 24.2584ZM26 13.5C26 19.8513 20.8513 25 14.5 25V27C21.9558 27 28 20.9558 28 13.5H26ZM14.5 2C20.8513 2 26 7.14873 26 13.5H28C28 6.04416 21.9558 0 14.5 0V2ZM3 13.5C3 7.14873 8.14873 2 14.5 2V0C7.04416 0 1 6.04416 1 13.5H3ZM4.99213 19.9713C3.73496 18.1282 3 15.9014 3 13.5H1C1 16.3161 1.86334 18.9335 3.33986 21.0983L4.99213 19.9713ZM1.91037 27.9138L5.07636 20.9486L3.25563 20.121L0.0896335 27.0862L1.91037 27.9138ZM7.7178 23.348L0.586197 26.5896L1.4138 28.4104L8.54541 25.1687L7.7178 23.348ZM14.5 25C12.3586 25 10.3567 24.4156 8.64181 23.3983L7.6214 25.1184C9.63664 26.3139 11.9897 27 14.5 27V25Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.8dda040f7fd9fcd167c6831ba9f8f376.svg";
export { ForwardRef as ReactComponent };